import './App.css';
import '@tickchak/react-share/app/index.css';
import ThemeProvider from '../src/theme/ThemeProvider';
import {router} from './router';
import {RouterProvider} from 'react-router-dom';

import useEvent401Exception from './hooks/useEvent401Exception';

import useGlassixWidget from './hooks/useGlassixWidget';
import {isETicketDomain} from './config/config';
import TickchakLoader from './component/tickchakLoader/TickchakLoader';

function App() {
    useEvent401Exception();
    useGlassixWidget(isETicketDomain);
    return (
        <ThemeProvider>
            <RouterProvider router={router} fallbackElement={<TickchakLoader showClass="show" cssStyle="position:fixed;" />} />
        </ThemeProvider>
    );
}

export default App;
